import { Dialog, DialogContent, DialogContentText, Grid } from '@material-ui/core';
import moment from 'moment';
import { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useHistory } from 'react-router-dom';
import _ from 'underscore';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import auth from '../../auth/Auth';
import authIdPositiva from '../../auth/AuthIdPositiva';
import { calcularTempoRestanteDecursoPrazo } from '../../common/DateUtil';
import { formatarNumeroFamiliar } from '../../common/formatadores';
import {
  getInformacaoPeriodoRetornoCadastramento,
  selectInformacaoPeriodoRetornoCadastramento,
} from '../../features/ConsultaSimples/consultaSimplesSlice';
import { mostrarExclusaoCadastralTutorial } from '../../features/Home/Home';
import {
  selecionarNumeroFamiliar,
  selecionarPerfil,
  selecionarTipoPerfil,
  selectPerfilCompleto,
  selectPerfis,
} from '../../features/Perfil/perfilSlice';
import { selectLoading, selectLoadingCount } from '../../globalSlice';
import { TipoPerfil } from '../../model/TipoPerfil';
import Card from '../Card/Card';
import FieldGroup from '../FieldGroup/FieldGroup';
import Message from '../Message/Message';
import styles from './DadosBasicos.module.css';
import { TipoMensagemBanner, getBannerInfo, selectBannerInfo, selectRecarregaBanner } from './dadosBasicosSlice';
import { getDecursoPrazo, selectDecursoPrazo } from '../../features/Suporte/SuporteSlice';
import { trackServiceSelect } from '../../common/tracker';

const DadosBasicos: React.FC<any> = (props) => {
  const dispatch = useAppDispatch();
  const history = useHistory();

  let perfil = useAppSelector(selectPerfilCompleto);
  const loadingCount = useAppSelector(selectLoadingCount);
  const isLoading = useAppSelector(selectLoading);
  const bannerInfo = useAppSelector(selectBannerInfo);
  const periodoFamiliaCadastramento = useAppSelector(selectInformacaoPeriodoRetornoCadastramento);
  const perfis = useAppSelector(selectPerfis);

  const [ultimaAtualizacaoOpen, setUltimaAtualizacaoOpen] = useState(false);
  const [atualizarAteOpen, setAtualizarAteOpen] = useState(false);
  const [situacaoCadastroFamiliaObtida, setSituacaoCadastroFamiliaObtida] = useState(false);

  const decursoPrazo = useAppSelector(selectDecursoPrazo);

  const recarregaBanner = useAppSelector(selectRecarregaBanner);

  useEffect(() => {
    dispatch(getDecursoPrazo());
  }, [])

  useEffect(()=>{
    if (!perfil) {
      perfil = auth.getPerfilSelecionado();
      const codigoTipoPerfil = auth.getTipoPerfilSelecionado();
      const numeroFamiliar = auth.getFamiliaSelecionada();

      dispatch(selecionarNumeroFamiliar(numeroFamiliar));
      dispatch(selecionarTipoPerfil(codigoTipoPerfil));

      const filtroPerfil = _.filter(perfis, perfil => {
        return perfil.tipoPerfil.codigo === codigoTipoPerfil && perfil.numeroFamiliar === numeroFamiliar;
      });

      dispatch(selecionarPerfil(filtroPerfil[0]));
    }
  }, [perfis]);

  useEffect(() => {
    if (auth.isAuthenticated() && perfil) {
      let identificadorPesquisado = perfil.identificador;
      // Caso o usuário seja um representante legal, passar o identificador de algum membro da família a qual ele está consultando.
      if (perfil?.tipoPerfil?.codigo === TipoPerfil.REPRESENTANTE_LEGAL) {
        dispatch(getBannerInfo({ nuFamiliar: perfil?.numeroFamiliar, isGovBr: true }));
      } else {
        dispatch(getBannerInfo({ identificador: identificadorPesquisado, isGovBr: true }));
      }
    } else if (authIdPositiva.isAuthenticated()) {
      dispatch(getBannerInfo({ identificador: authIdPositiva.getUserId(), isGovBr: false }));
    }
  }, [dispatch, perfil, recarregaBanner]);

  useEffect(() => {
    if (perfil && perfil.identificador) {
      if (!situacaoCadastroFamiliaObtida) {
        setSituacaoCadastroFamiliaObtida(true);

        let identificadorPesquisado = perfil.identificador;
        // Caso o usuário seja um representante legal, passar o identificador de algum membro da família a qual ele está consultando.
        if (perfil?.tipoPerfil?.codigo === TipoPerfil.REPRESENTANTE_LEGAL) {
          if (perfil?.integrantesFamilia[0]?.id) {
            identificadorPesquisado = perfil?.integrantesFamilia[0]?.id;
          }
        }

        dispatch(
          getInformacaoPeriodoRetornoCadastramento({
            identificador: identificadorPesquisado,
            history,
          })
        );
      }
    }

    return () => {
      setSituacaoCadastroFamiliaObtida(false);
    };
  }, [dispatch, history]);

  const calcularTempoParaDesatualizar = () => {
    const meses = moment(perfil?.dataAtualizacaoFamilia)
      .add(2, 'years')
      .diff(moment(), 'months', true);
    if (Math.floor(meses) > 0) {
      const mesesArredondado = Math.round(meses);
      let monthCount = mesesArredondado === 1 ? 'mês' : 'meses';
      return `${mesesArredondado} ${monthCount}`;
    }
    const dias = Math.ceil(
      moment(perfil?.dataAtualizacaoFamilia).add(2, 'years').diff(moment(), 'days', true)
    );
    let dayCount = dias === 1 ? 'dia' : 'dias';
    return `${dias} ${dayCount}`;
  };

  // const direcionarAtualizacaoCadastral = () => {
  //   history.push('/atualizacaoCadastralPorConfirmacao');
  // }

  const caixaMensagens = () => {
    trackServiceSelect('POR-MENU', "CAIXA DE MENSAGEM");
    history.push('/caixa-mensagem');
  };

  const detalharMensagem = (mensagem: any) => {
    history.push({
      pathname: '/caixa-mensagem-detalhe',
      state: {
        mensagemSelecionada: mensagem,
      },
    });
  };

  const exibirIntegrantes = () => {
    if (auth.isAuthenticated()) {
      // Logado pelo gov.br, redirecionar para a tela de integrantes da consulta ao formulário
      const historyParams = {
        pathname: '/consultaCompleta',
        state: { mostrarIntegrantes: true }
      };
      if (history.location?.pathname === '/consultaCompleta') {
        history.replace(historyParams);
      } else {
        history.push(historyParams);
      }
    } else if (authIdPositiva.isAuthenticated()) {
      // Na identificação positiva, redirecionar para tela de dados resumidos da família.
      history.push({
        pathname: '/consultaSimples',
        state: { mostrarIntegrantes: true }
      });
    }
  };

  const exibirRepresentanteLegal = () => {
    if (auth.isAuthenticated()) {
      // Logado pelo gov.br, redirecionar para a tela de Representante Legal da consulta ao formulário
      const historyParams = {
        pathname: '/consultaCompleta',
        state: { mostrarRepresentanteLegal: true, origem: history.location?.pathname }
      };
      if (history.location?.pathname === '/consultaCompleta') {
        history.replace(historyParams);
      } else {
        history.push(historyParams);
      }
    } else if (authIdPositiva.isAuthenticated()) {
      // Na identificação positiva, redirecionar para tela de dados resumidos da família.
      history.push({
        pathname: '/consultaSimples',
        state: { mostrarRepresentanteLegal: true }
      });
    }
  };

  const exibirMsgAtualizacaoCadastral = (codigo) => {
    if (codigo == 7) {
      return (
        <div className={styles.textoDialogo}>
          Data da última atualização cadastral feita pela integração de dados.
        </div>
      );
    }

    return (
      <div className={styles.textoDialogo}>
        Data da última atualização cadastral feita pela família.
      </div>
    );
  };

  return (
    <>
     <Dialog open={ultimaAtualizacaoOpen} onClose={() => setUltimaAtualizacaoOpen(false)}>
        <DialogContent>
          <DialogContentText>
            {exibirMsgAtualizacaoCadastral(perfil?.tipoCondicaoCadastroFamiliar?.codigo)}
          </DialogContentText>
        </DialogContent>
      </Dialog>

      <Dialog open={atualizarAteOpen} onClose={() => setAtualizarAteOpen(false)}>
        <DialogContent>
          <DialogContentText>
            <div className={styles.textoDialogo}>
              Data limite para que sua família atualize suas informações no Cadastro Único.
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      <div className={`${styles.headerCard} ${props.className ? props.className : ''}`}>
        <Grid container spacing={2}>
          <Grid item xs={6} sm={3}>
            <FieldGroup
              label="Código familiar"
              value={formatarNumeroFamiliar(perfil?.numeroFamiliar)}
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <FieldGroup label="Estado cadastral" value={perfil?.tipoEstadoCadastralFamilia?.nome} />
          </Grid>
          <Grid item xs={6} sm={3}>
            <FieldGroup
              label={<>
                <div>Última atualização
                  <i
                    className={`fas fa-question-circle ${styles.helpIcon}`}
                    onClick={() => setUltimaAtualizacaoOpen(true)}
                  />
                </div>
              </>}
              value={periodoFamiliaCadastramento ? '-' :
                perfil?.dataAtualizacaoFamilia
                  ? moment(perfil?.dataAtualizacaoFamilia).format('DD/MM/YYYY')
                  : null
              }
            />
          </Grid>

          <Grid item xs={6} sm={3}>
            <FieldGroup
              label={<>
                <div>Atualizar até
                  <i
                    className={`fas fa-question-circle ${styles.helpIcon}`}
                    onClick={() => setAtualizarAteOpen(true)}
                  />
                </div>
              </>}
              value={periodoFamiliaCadastramento ? '-' : perfil?.dataAtualizacaoFamilia
                ? moment(perfil?.dataAtualizacaoFamilia).add(2, 'years').format('DD/MM/YYYY')
                : null
              }
            />
          </Grid>
        </Grid>
      </div>

      {loadingCount <= 0 &&
        <>
          {bannerInfo?.tipoMensagemBanner.codigo === TipoMensagemBanner.FAMILIA_FORMADA_1_PESSOA && (
            <Message
              type="error"
              className={styles.message}
              title={`ATENÇÃO!`}
              text={
                <>
                  Você se cadastrou sozinho(a). Se você mora com outras pessoas,&nbsp;
                  <span className={styles.enfaseContent}>clique aqui</span>.
                </>
              }
              onClick={() => mostrarExclusaoCadastralTutorial(history, false)}
            />
          )}
          {bannerInfo?.tipoMensagemBanner.codigo === TipoMensagemBanner.FAMILIA_SEM_REGISTRO_CIVIL && (
            <Message
              type="warning"
              className={styles.message}
              title={`Procure o posto de atendimento do Cadastro Único para apresentar os documentos de identificação.`}
            />
          )}
          {bannerInfo?.tipoMensagemBanner.codigo === TipoMensagemBanner.FAMILIA_EM_CADASTRAMENTO && (
            <Message
              type="warning"
              className={styles.message}
              title={` As informações da solicitação de cadastramento de sua família foram inseridas com sucesso. Mas não se esqueça! Para concluir seu cadastro, o(a) Responsável Familiar deve ir até um CRAS ou posto de atendimento do Cadastro Único em até ${calcularTempoRestanteDecursoPrazo(periodoFamiliaCadastramento?.dataCadastramento, decursoPrazo)} dias.`}
            />
          )}

          {bannerInfo?.tipoMensagemBanner.codigo === TipoMensagemBanner.FAMILIA_POSSUI_PELO_MENOS_2_PENDENCIAS && (
            <Message
              type="error"
              className={styles.message}
              title={`ATENÇÃO!`}
              text={
                <>
                  O cadastro da sua família está em Qualificação cadastral.<br/>
                  <span className={styles.enfaseContent}>Verifique sua caixa de mensagem.</span>
                </>
              }
              onClick={() => caixaMensagens()}
            />
          )}

          {bannerInfo?.tipoMensagemBanner.codigo === TipoMensagemBanner.FAMILIA_ATUALIZADA && (
            <Message
              type="success"
              className={styles.message}
              title={`Parabéns! O cadastro da sua família está atualizado.`}
            />
          )}
          {bannerInfo?.tipoMensagemBanner.codigo === TipoMensagemBanner.FAMILIA_FICARA_DESATUALIZADA && (
            <Message
              type="warning"
              className={styles.message}
              title={`O cadastro da sua família ficará desatualizado em ${calcularTempoParaDesatualizar()}.`}
              // text={
              //   <>
              //     <span className={styles.enfaseContent}>Atualize</span> seus dados agora.
              //   </>
              // }
              // onClick={() => direcionarAtualizacaoCadastral()}
            />
          )}
          {bannerInfo?.tipoMensagemBanner.codigo === TipoMensagemBanner.FAMILIA_ESTA_DESATUALIZADA && (
            <Message
              type="error"
              className={styles.message}
              title={`O cadastro da sua família está desatualizado.`}
              // text={
              //   <>
              //     <span className={styles.enfaseContent}>Atualize</span> seus dados agora.
              //   </>
              // }
              //onClick={() => direcionarAtualizacaoCadastral()}
            />
          )}
          {bannerInfo?.tipoMensagemBanner.codigo === TipoMensagemBanner.FAMILIA_ESTA_AVERIGUACAO_RENDA_E_COMPOSICAO_FAMILIAR && (
            <Message
              type="error"
              className={styles.message}
              title={`O cadastro da sua família está em averiguação de renda e composição familiar.`}
              text={
                <>
                  <span className={styles.enfaseContent}>Verifique sua caixa de mensagem.</span>
                </>
              }
              onClick={() => caixaMensagens()}
            />
          )}
          {bannerInfo?.tipoMensagemBanner.codigo === TipoMensagemBanner.FAMILIA_ESTA_AVERIGUACAO_DE_COMPOSICAO_FAMILIAR && (
            <Message
              type="error"
              className={styles.message}
              title={`O cadastro da sua família está em averiguação de composição familiar.`}
              text={
                <>
                  <span className={styles.enfaseContent}>Saiba o que fazer.</span>
                </>
              }
              onClick={() => detalharMensagem(bannerInfo?.mensagemDetalhe)}
            />
          )}
          {bannerInfo?.tipoMensagemBanner.codigo === TipoMensagemBanner.FAMILIA_ESTA_DIFERENTE_OUTRAS_BASES_GOVERNO && (
            <Message
              type="error"
              className={styles.message}
              title={`Os dados do cadastro da sua família estão diferentes de outras bases do governo.`}
              text={
                <>
                  <span className={styles.enfaseContent}>Saiba o que fazer.</span>
                </>
              }
              onClick={() => detalharMensagem(bannerInfo?.mensagemDetalhe)}
            />
          )}
          {bannerInfo?.tipoMensagemBanner.codigo === TipoMensagemBanner.FAMILIA_CADASTRO_DESATUALIZADO_INCLUIDO_REVISAO_CADASTRAL && (
            <Message
              type="error"
              className={styles.message}
              title={`Seu cadastro está desatualizado e foi incluído em Revisão Cadastral.`}
              // text={
              //   <>
              //     <span className={styles.enfaseContent}>Atualize seus dados agora.</span>
              //   </>
              // }
              // onClick={() => direcionarAtualizacaoCadastral()}
            />
          )}
          {bannerInfo?.tipoMensagemBanner.codigo === TipoMensagemBanner.FAMILIA_SEM_RF && (
            <Message
              type="error"
              className={styles.message}
              title={
                <>
                O cadastro de sua família não possui um responsável familiar cadastrado. <br/>
                É preciso que o novo responsável familiar compareça ao CRAS para realizar a atualização cadastral da família.
                </>
              }
            />
          )}
          {bannerInfo?.tipoMensagemBanner.codigo === TipoMensagemBanner.FAMILIA_COM_MAIS_DE_UM_RF && (
            <Message
              type="error"
              className={styles.message}
              title={
                <>
                O cadastro de sua família possui mais de um responsável familiar cadastrado. <br/>
                É preciso que o novo responsável familiar compareça ao CRAS para realizar a atualização cadastral da família.
                </>
              }
            />
          )}
          {bannerInfo?.tipoMensagemBanner.codigo === TipoMensagemBanner.INTEGRANTE_INDICATIVO_OBITO_MAIS_INFORMACOES && (
            <Message
              type="error"
              className={styles.message}
              title={`ATENÇÃO!`}
              text={
                <>
                  Existe uma pessoa na família com registro de falecimento.<br/>
                  O {perfil.temRL ? 'representante legal' : 'responsável familiar'} pode
                  ir ao CRAS atualizar o Cadastro Único ou realizar a exclusão por motivo de falecimento na tela de integrantes familiares.
                  {history.location?.pathname !== '/consultaSimples' && (
                    <div>
                      Para mais informações&nbsp;
                      <span className={styles.enfaseContent}>clique aqui</span>.
                    </div>
                  )}
                </>
              }
              onClick={() => exibirIntegrantes()}
            />
          )}
          {bannerInfo?.tipoMensagemBanner.codigo === TipoMensagemBanner.RF_INDICATIVO_OBITO_REGULAR_PENDENCIA && (
            <Message
              type="error"
              className={styles.message}
              title={`ATENÇÃO!`}
              text={
                <>
                  {perfil.temRF && (
                    <>
                      O responsável familiar está com registro de falecimento. Vá ao CRAS
                      atualizar o Cadastro Único.
                      {history.location?.pathname !== '/consultaSimples' && (
                        <div>
                          Para mais informações&nbsp;
                          <span className={styles.enfaseContent}>clique aqui</span>.
                        </div>
                      )}
                    </>
                  )}
                  {perfil.temRL && (
                    <>
                      O representante legal está com registro de falecimento. Vá ao CRAS
                      atualizar o Cadastro Único.
                      {history.location?.pathname !== '/consultaSimples' && (
                        <div>
                          Para mais informações&nbsp;
                          <span className={styles.enfaseContent}>clique aqui</span>.
                        </div>
                      )}
                    </>
                  )}
                </>
              }
              onClick={() => {
                if (perfil.temRF) {
                  return exibirIntegrantes();
                }
                if(perfil.temRL ){
                  return exibirRepresentanteLegal();
                }
              }}
            />
          )}
        </>
      }
      {(isLoading || loadingCount > 0) && !bannerInfo?.mensagemDetalhe &&
        <Card>
          <Skeleton count={2} />
          <br />
        </Card>
      }
    </>
  );
};

export default DadosBasicos;
